import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { BinEvent } from '../shared/interfaces/bin-event';
import { BinEventCrudService } from '../shared/services/bin-event-crud.service';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-bin-events',
  templateUrl: './bin-events.component.html',
  styleUrls: ['./bin-events.component.scss']
})
export class BinEventsComponent implements OnInit {

  
  bins: BinEvent[];
  bin: BinEvent;
  selectedBins: BinEvent[] = [];

  binDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private binEventService : BinEventCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService,
    private router: Router
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Bin Management'},
      {label: 'Bin History'}
    ];

    this.bins = [];
    this.bin = { } as BinEvent ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.binEventService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.bins = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : BinEvent = jsonItem as BinEvent;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.bins.push(l);
        }
      })
    });

    // column management
    this.cols = [
      { field: 'name', header: 'Title' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'createdAt', header: 'Created at' },
      { field: 'createdBy', header: 'Created by' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we don't show at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'tags');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

  // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.binEventService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.bins);
            doc.save('bins.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.bins);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "bins");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedBins);
      // console.log('SAVEC CSV LOCATIONS ', this.bins);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedBins, 'bins', exportCols);
   // this.exportService.exportToCsv(this.bins, 'bins', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.bin = {} as BinEvent;
    this.submitted = false;
    this.binDialog = true;
  }

  deleteSelectedBins() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected bins?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.bins = this.bins.filter(val => !this.selectedBins.includes(val));
           
            this.selectedBins.forEach( bin => this.binEventService.delete(bin.$key));
            this.selectedBins = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Binss Deleted', life: 3000});
        }
    });
  }

  editBin(bin: BinEvent) {
    this.bin = {...bin};
    this.binDialog = true;
  }

  deleteBin(bin: BinEvent) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + bin.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.bins = this.bins.filter(val => val.$key !== bin.$key);
            this.bin = {} as BinEvent;
            this.binEventService.delete(bin.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Bin Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.binDialog = false;
    this.submitted = false;
  }

  saveBin() {
    this.submitted = true;

    if ( this.bin.name.trim() ) {
      this.bin.isEnabled = true;
      
      if (this.bin.$key) {
          this.bins[this.findIndexById(this.bin.$key)] = this.bin;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Bin Updated', life: 3000});
          this.binEventService.update(this.bin);
        } else {
          this.bin.position = this.bins.length;
          this.binEventService.add(this.bin);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Bin Created', life: 3000});
      this.bins = [...this.bins];
    }

    this.binDialog = false;
    this.bin = { } as BinEvent;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.bins.length; i++) {
        if (this.bins[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeBin(bin : BinEvent) {
    //console.log("SAVE", bin);
    this.binEventService.update(bin);
  }

  completePosition(bin : BinEvent) {
   // console.log("SAVE", bin);
  //  this.binService.updateBin(bin);


    if ( this.newPosition > -1 ) {
        bin.position = this.newPosition;
        bin = this.checkPositionLimits(bin);
        this.reorderElements(bin);
        //this.updateDB(bin);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.bins);
    // const myClonedArray = [];
    // this.bins.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.bins.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.bins.length - 1 - event.dropIndex;
    const binToMove = this.bins[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.bins[index] = this.bins[index+1];
        this.bins[index].position = index;
        this.binEventService.update(this.bins[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.bins[index] = this.bins[index-1];
        this.bins[index].position = index;
        this.binEventService.update(this.bins[index]);
      }
    } 
    this.bins[endIndex] = binToMove;
    this.bins[endIndex].position = endIndex;
    this.binEventService.update(this.bins[endIndex]);
  }

  // onFieldEdit(bin: Spray, fieldName: string): void {
  //   //console.log(this.bins);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + bin[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       bin.position = this.newPosition;
  //       bin = this.checkPositionLimits(bin);
  //       this.reorderElements(bin);
  //       //this.updateDB(bin);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(bin);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.bins.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, bin: BinEvent) {
    // console.log("event" +event);
    if (bin.position != null && bin.position > -1) {
      this.previousPosition = bin.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(bin: BinEvent) {
    console.log('check ',bin.position + ' ' + this.bins.length);
    if (!bin.position) {
     // console.log('check 1');
      return this.bin;
    }
    if (bin.position < 0) {
      bin.position = 0;
      // console.log('check 2');
      return bin;
    }
    if (bin.position > this.bins.length) {
      bin.position = this.bins.length - 1;
    //  console.log('check 3', bin.position);
      return bin;
    }
   // console.log('check 4');
    return bin;
  }

  async reorderElements(bin: BinEvent) {
    this.newPosition = this.newPosition  > this.bins.length ? this.bins.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === bin.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const binToMove = this.bins[startIndex];
   // console.log('Item to move: ', this.bins[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.bins);
        console.log('Item to +1: ', this.bins[index+1]);

        this.bins[index] = this.bins[index+1];
        this.bins[index].position = index;
        // console.log('Move: ', this.bins[index+1]);
        // console.log('Move pos: ', this.bins[index].position);
        //await this.updateDB(this.bins[index]);
        this.binEventService.update(this.bins[index]);
     //   console.log('Update DB: ', this.bins[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.bins[index] = this.bins[index-1];
        this.bins[index].position = index;
        this.binEventService.update(this.bins[index]);
      }
    } 
    this.bins[endIndex] = binToMove;
    this.bins[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.binEventService.update(this.bins[endIndex]);
    
    // const myClonedArray = [];
    // this.bins.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.bins = myClonedArray;
   // this.getAllRecords();
  }
}
